import { VisibilityEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';

const ADMIN_VISIBILITY: VisibilityEnum[] = ['superAdmin', 'all'];
const USER_VISIBILITY: VisibilityEnum[] = ['all'];

/**
 * Какие шаблоны трансляций организации видит пользователь: супер-админ — ещё и служебные (`superAdmin`).
 *
 * Одна функция на всех читателей списка (редактор табло, форма турнира): `visibility` входит в ключ кэша
 * RTK Query, и разойдись они в порядке значений — один и тот же список грузился бы дважды. Массивы —
 * константы, чтобы аргумент запроса не менялся по ссылке на каждый рендер.
 */
export function getBoardTemplateVisibility(isAdmin: boolean): VisibilityEnum[] {
  return isAdmin ? ADMIN_VISIBILITY : USER_VISIBILITY;
}
